import { render } from "./IncentiveComponent.vue?vue&type=template&id=0439f068&scoped=true&ts=true"
import script from "./IncentiveComponent.vue?vue&type=script&lang=ts"
export * from "./IncentiveComponent.vue?vue&type=script&lang=ts"

import "./IncentiveComponent.vue?vue&type=style&index=0&id=0439f068&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0439f068"]])

export default __exports__